import {GatedExecutor} from "./gated_executor";

export const onceDocumentReady = new GatedExecutor();
